import { compose } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { PureComponent } from "react";

import { Grid, Tooltip, IconButton, withStyles } from "@material-ui/core";

import {
  skillsOnLoad,
  skillsOnUnload,
  createSkillOnSubmit,
  initializeCreateSkill,
  deleteSkillAskConfirmation,
  deleteSkillListAskConfirmation,
  getStatsForSkills,
} from "features/competence.actions";

import {
  getSkillsFromState,
  getSkillStatsBySkillIdFromState,
} from "features/competence.selectors";

import routePaths from "app/routePaths";
import { ACTIONS, ICONS, EMPTY_MAP } from "app/app.constants";
import CrudBasePage from "app/components/CrudBasePage";
import { SKILL_FORM } from "features/competence.constants";
import SkillForm from "features/hr/skills/components/SkillForm";
import { getSummarizedDataStatesFromState } from "app/app.selectors";
import SkillProgressBar from "features/skill/SkillProgressBar";

class SkillsContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad, dispatchGetStatsForSkills } = this.props;

    dispatchOnLoad();
    dispatchGetStatsForSkills();
  }

  componentWillUnmount() {
    const { dispatchOnUnload } = this.props;

    dispatchOnUnload();
  }

  columns = [
    {
      xs: 4,
      title: "Skill Name",
      getSortProperty: item => item.get("name"),
    },
    {
      xs: true,
      filter: {
        label: "Group",
        defaultText: "All groups",
      },
      title: "Group",
      getSortProperty: item => item.get("skillGroupName"),
    },
    {
      xs: true,
      filter: {
        multiple: true,
        label: "Type",
        defaultText: "All types",
      },
      title: "Type",
      getSortProperty: item => item.get("skillTypeName"),
    },
    {
      xs: true,
      title: "Valid",
      getSortProperty: item => item.get("validityMonthsString"),
    },
    {
      filter: {
        defaultText: "Any",
        label: "Countries",
        getFilterText: filter => (filter === "" ? "Global" : filter),
      },
      xs: 1,
      title: "Countries",
      getSortProperty: item =>
        item
          .get("countries")
          .map(c => c.get("twoLetterCode"))
          .join(", "),
    },
    {
      xs: 1,
      title: "Evidence",
      getSortProperty: item => item.get("requiredEvidenceCount"),
    },
    {
      xs: 1,
      container: true,
      justify: "center",
      title: (
        <Tooltip title="Role Count">
          <ICONS.ROLE />
        </Tooltip>
      ),
      getSortProperty: item =>
        this.props.skillStatsBySkillId.getIn(
          [item.get("skillId").toString(), "rolesCount"],
          "-",
        ),
    },
    {
      xs: 1,
      container: true,
      justify: "center",
      title: (
        <Tooltip title="Member Count">
          <ICONS.TEAM />
        </Tooltip>
      ),
      getSortProperty: item =>
        this.props.skillStatsBySkillId.getIn(
          [item.get("skillId").toString(), "memberCount"],
          "-",
        ),
    },
    {
      xs: true,
      component: Grid,
      title: "Coverage",
      getValue: item => (
        <SkillProgressBar skillId={item.get("skillId").toString()} />
      ),
    },
  ];

  actions = [
    {
      getValue: item => (
        <Tooltip title="Delete">
          <IconButton onClick={() => this.props.dispatchDeleteSkill(item)}>
            <ICONS.DELETE fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  listActions = [
    {
      renderAction: ({ selectedItems }) => (
        <IconButton
          classes={{
            root: styles.iconButtonRoot,
          }}
          disabled={!selectedItems.size}
          onClick={() => this.props.dispatchDeleteSkills(selectedItems)}
        >
          <ICONS.DELETE />
        </IconButton>
      ),
      getTitle: selectedItems => `Delete (${selectedItems.size})`,
    },
  ];

  render() {
    const {
      skills,
      dataState,
      breadcrumb,
      dispatchOnLoad,
      dispatchCreateSkillOnSubmit,
      dispatchInitializeCreateSkill,
    } = this.props;

    return (
      <CrudBasePage
        items={skills}
        displayAddButton
        title={breadcrumb}
        displaySearchField
        Icon={ICONS.SKILL}
        CreateEntityFormComponent={SkillForm}
        dataState={dataState}
        SortableListProps={{
          selectable: true,
          columns: this.columns,
          actions: this.actions,
          onRefresh: dispatchOnLoad,
          displayNumberOfItems: true,
          listActions: this.listActions,
          getKey: item => item.get("skillId"),
          createSortableListRowProps: item => ({
            component: Link,
            to: `${routePaths.hrPortal}/skills/${item.get("skillId")}`,
          }),
        }}
        CreateModalProps={{
          submitText: "Add",
          title: "Add Skill",
          onSubmit: dispatchCreateSkillOnSubmit,
          onEnter: dispatchInitializeCreateSkill,
        }}
        createEntityForm={{
          form: SKILL_FORM.ID,
        }}
      />
    );
  }
}

SkillsContainer.defaultProps = {
  skillStatsBySkillId: EMPTY_MAP,
};

const styles = theme => ({
  iconButtonRoot: {
    padding: theme.spacing(1),
  },
});

export default compose(
  connect(
    state => ({
      skills: getSkillsFromState(state),
      skillStatsBySkillId: getSkillStatsBySkillIdFromState(state),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_SKILLS,
        ACTIONS.DELETE_SKILL,
        ACTIONS.DELETE_SKILLS,
      ),
    }),
    {
      dispatchOnLoad: skillsOnLoad,
      dispatchOnUnload: skillsOnUnload,
      dispatchGetStatsForSkills: getStatsForSkills,
      dispatchDeleteSkill: deleteSkillAskConfirmation,
      dispatchCreateSkillOnSubmit: createSkillOnSubmit,
      dispatchInitializeCreateSkill: initializeCreateSkill,
      dispatchDeleteSkills: deleteSkillListAskConfirmation,
    },
  ),
  withStyles(styles),
)(SkillsContainer);
